<template>
    <div>
        <dynamic-form :formConfig="formConfig" v-model="form" @submit="submit"></dynamic-form>
    </div>
</template>
<script>
import '@/components/dynamic-form';
export default {
    data() {
        return {
            form: {
                remoteLikes1: 'A',
                like: 'suanzao'
            },
            formConfig: {
                inline: true,
                labelPosition: "right",
                labelWidth: "",
                size: "small",
                statusIcon: true,
                formItemList: [
                    {
                        span: 12,
                        type: "select",
                        label: "单选",
                        value: "",
                        disabled: false,
                        multiple: false,
                        placeholder: "请选择",
                        rules: [{
                                required: true,
                                message: "不能为空",
                                trigger: "blur"
                            }
                        ],
                        key: "like",
                        options: [
                            {
                                value: "suanzao",
                                label: "蒸酸枣",
                                disabled: false
                            },
                            {
                                value: "yaogao",
                                label: "蒸羊羔",
                                disabled: false
                            },
                            {
                                value: "mantou",
                                label: "蒸馒头",
                                disabled: false
                            }
                        ]
                    },
                    {
                        span: 12,
                        type: "select",
                        label: "单选(动态)",
                        value: "",
                        disabled: false,
                        multiple: false,
                        placeholder: "请选择",
                        rules: [],
                        key: "remoteLike",
                        dicType: 'USER_LABLE',
                        remote: true,
                        optionsUrl: "/dynamic/getDicData"
                    },
                    {
                        span: 12,
                        type: "select",
                        label: "多选",
                        value: [],
                        disabled: false,
                        multiple: true,
                        placeholder: "请选择",
                        rules: [],
                        key: "likes",
                        options: [
                            {
                                value: "suanzao",
                                label: "蒸酸枣",
                                disabled: false
                            },
                            {
                                value: "yaogao",
                                label: "蒸羊羔",
                                disabled: false
                            },
                            {
                                value: "mantou",
                                label: "蒸馒头",
                                disabled: false
                            }
                        ]
                    },
                    {
                        span: 12,
                        type: "select",
                        label: "多选(动态)",
                        value: [],
                        disabled: false,
                        multiple: true,
                        placeholder: "请选择",
                        rules: [],
                        key: "remoteLikes",
                        dicType: 'USER_LABLE',
                        optionsUrl: "/dynamic/getDicData"
                    },
                    {
                        span: 12,
                        type: "select",
                        label: "级联(动态)",
                        value: '',
                        disabled: false,
                        multiple: false,
                        placeholder: "请选择",
                        rules: [],
                        key: "remoteLikes1",
                        dicType: 'USER_LABLE',
                        optionsUrl: "/dynamic/getDicData"
                    },
                    {
                        span: 12,
                        type: "select",
                        cascade: 'remoteLikes1',
                        label: "级联(动态)",
                        value: '',
                        disabled: false,
                        multiple: false,
                        params: {userId: '2222222222',dicType: 'USER_LABLE'},
                        placeholder: "请选择",
                        rules: [],
                        key: "remoteLikes2",
                        dicType: 'USER_LABLE',
                        optionsUrl: "/dynamic/getDicData"
                    },
                    {
                        span: 12,
                        type: "select",
                        cascade: 'remoteLikes2',
                        label: "级联(动态)",
                        value: '',
                        disabled: false,
                        multiple: false,
                        params: {userId: '33333',dicType: 'USER_LABLE'},
                        placeholder: "请选择",
                        rules: [],
                        key: "remoteLikes3",
                        dicType: 'USER_LABLE',
                        optionsUrl: "/dynamic/getDicData"
                    },
                    {
                        span: 12,
                        label: '树型下拉多选',
                        key: 'area3',
                        type: 'treeSelect',
                        multiple: false,
                        value: 'nanchang',
                        clearable: true,
                        options: [
                            {
                                label: '江西',
                                value: 'jiangxi',
                                children: [
                                    {
                                        label: '南昌',
                                        value: 'nanchang',
                                        disabled: true
                                    },
                                    {
                                        label: '宜春',
                                        value: 'yichun',
                                    },
                                    {
                                        label: '鹰潭',
                                        value: 'yintan',
                                    },
                                ]
                            },
                        ],
                        rules: {
                            required: true, message: '不能为空', trigger: 'blur'
                        }
                    },
                ]
            },
        }
    },
    methods: {
        submit(v) {
            console.log(v)
        }
    }
}
</script>
